import React, { useEffect } from "react";
import styles from "./Message.module.scss";
import successIcon from "../../assets/images/icons/success-meassage-icon.svg";
import errorIcon from "../../assets/images/icons/error-message-icon.svg";
import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import { closeMessage } from "../../store/message/messageSlice";

const Message = () => {
  const { title, type } = useAppSelector((state) => state.messageSlice.message);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (title) {
      const timeout = setTimeout(() => {
        dispatch(closeMessage());
      }, 2500);
      return () => clearTimeout(timeout);
    }
  }, [title]);

  const findIconForMessage = (value: "success" | "error" | "warning" | null) => {
    let icon;
    switch (value) {
      case "success":
        icon = successIcon;
        break;
      case "error":
        icon = errorIcon;
        break;
      default:
        icon = successIcon;
        break;
    }
    return icon;
  };

  return (
    <>
      {title && (
        <div className={`${styles.container}`}>
          <div className={`${styles.row} ${styles[type ? type : ""]}`}>
            <img className={styles.image} src={findIconForMessage(type)} alt={type ? type : ""} />
            <h4 className={styles.title}>{title}</h4>
          </div>
        </div>
      )}
    </>
  );
};

export default Message;
